import styled from 'styled-components';
import { Typography } from '../../../global/theme';
import { AlignCenter, FlexBetween } from '../../../global/commonStyle';

const Bottom = styled.div`
  padding: var(--space-16);
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-16);
`;

const Action = styled.div`
  border: 0.5px solid var(--border-primary);
  padding: var(--space-7) var(--space-11);
  background-color: var(--background-primary);
  ${AlignCenter}
  gap: var(--space-10);
  border-radius: var(--border-radius-6);
  cursor: pointer;
  max-width: 152px;
  width: 100%;
  p {
    ${Typography.body_md_medium}
    color: var(--text-primary);
    margin: var(--space-0);
  }
  &:hover {
    background-color: var(--background-secondary);
  }
`;
const Icon = styled.div`
  width: 18px;
  height: 18px;
  .html {
    path {
      fill: var(--text-primary);
    }
  }
  .coming-soon-icon {
    path {
      stroke: var(--text-secondary);
    }
    rect {
      stroke: var(--text-secondary);
    }
  }
`;

const NotionAction = styled.div`
  max-width: 152px;
  width: 100%;
  border: 0.5px solid var(--border-primary);
  padding: var(--space-7) var(--space-11);
  background-color: var(--background-primary);
  ${FlexBetween}
  border-radius: var(--border-radius-6);
  gap: var(--space-10);
  cursor: pointer;
  display: none;
  &:hover {
    background-color: var(--background-secondary);
  }
`;
const LeftSide = styled.div`
  ${AlignCenter}
  gap: var(--space-10);
  p {
    ${Typography.body_md_medium}
    color: var(--text-primary);
    margin: var(--space-0);
  }
`;
export { Bottom, Action, Icon, NotionAction, LeftSide };
